import { OperationsModes } from "@/common/fields/operations-modes";

// api-publica-docs-y-permisos: los permisos de una key son los mismos
// slugs de los roles; el portal solo los agrupa por recurso para mostrarlos.
export const API_KEY_RESOURCE_LABELS = {
    products: "Productos",
    lines: "Líneas",
    collections: "Colecciones",
    blogs: "Páginas personalizadas",
    orders: "Pedidos"
};

export const apiKeyResourceLabel = (resource) =>
    API_KEY_RESOURCE_LABELS[resource] || resource;

// Fuera de multi-tenant el tope es fijo; en multi-tenant sale del
// entitlement `apiKeys` del plan.
export const API_KEYS_FIXED_LIMIT = 5;

export const API_KEYS_RESOURCE_CODE = "apiKeys";

export const API_DOCS_MULTI_TENANT_URL =
    "https://tucatalogo.co/desarrolladores";

export const apiDocsUrl = (operationMode, apiUrl) =>
    operationMode === OperationsModes.multiTenant
        ? API_DOCS_MULTI_TENANT_URL
        : `https://editor.swagger.io/?url=${apiUrl}/api/docs.json`;

const slugPrefix = (slug) => String(slug).split(":")[0];

// Permisos de una key agrupados en el orden del catálogo
// (`GET /bo/api-keys/permissions`). Un slug que no esté en el catálogo cae
// en un grupo por su prefijo, para no esconder nunca un permiso real.
export const groupApiKeyPermissions = (slugs = [], groups = []) => {
    const pending = new Set(slugs);
    const result = [];

    groups.forEach((group) => {
        const permissions = group.permissions
            .filter((permission) => pending.has(permission.slug))
            .map(({ name, slug }) => ({ slug, name }));
        permissions.forEach(({ slug }) => pending.delete(slug));
        if (permissions.length) {
            result.push({
                resource: group.resource,
                label: apiKeyResourceLabel(group.resource),
                permissions,
                total: group.permissions.length
            });
        }
    });

    const unknownGroups = {};
    [...pending].forEach((slug) => {
        const resource = slugPrefix(slug);
        if (!unknownGroups[resource]) {
            unknownGroups[resource] = {
                resource,
                label: apiKeyResourceLabel(resource),
                permissions: [],
                total: null
            };
            result.push(unknownGroups[resource]);
        }
        unknownGroups[resource].permissions.push({ slug, name: slug });
    });

    return result;
};
